import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Passenger } from 'src/app/core/models/itinerary.model';
import { ContractError } from 'src/app/core/models/models';

@Component({
  selector: 'app-ancillaries-modal',
  templateUrl: './ancillaries-modal.component.html',
  styleUrls: ['./ancillaries-modal.component.scss']
})
export class AncillariesModalComponent {
  @Input() passengers: Passenger[];
  @Input() isActive = false;
  @Input() error: ContractError;
  @Output() closeModal: EventEmitter<void> = new EventEmitter();

  handleCloseModal(): void {
    this.isActive = false;
    this.closeModal.emit();
  }
}
